<section id="dropdownTripChangeArea" class="flex absolute items-start mt-2.5 mr-14 right-0 z-10 gap-1" [ngClass]="styles()">
    @if (showCreate()) {
        <div (click)="createTownEventEmitter.emit()" [title]="literalService.get('towns.actions.newTown.button', true)" class="flex items-center justify-center h-10 w-10 rounded bg-white border cursor-pointer hover:bg-gray-50 shadow">
            <img [src]="images.create" alt="new town" class="h-6 w-6" />
        </div>
    }
    <div class="flex flex-col h-10 w-55 gap-1.5">
        <div class="relative area-selector">
            <div class="flex w-full justify-between items-center cursor-pointer bg-white border p-1.25" [ngClass]="showTowns ? 'rounded-t' : 'rounded'" (click)="handleTowns()">
                <div class="flex items-center truncate">
                    <img [src]="images.area" alt="area" class="h-6 w-6 mr-2 shrink-0" />
                    <span class="truncate">
                        <span class="font-semibold text-xl">{{ headerLabel }}</span>
                        @if (headerSuffix) {
                            <span class="font-light text-base ml-1 text-neutrals-grey-05">{{ headerSuffix }}</span>
                        }
                    </span>
                </div>
                <img [src]="images.arrowDown" alt="arrow" class="h-3 w-3 ml-2 shrink-0" [ngClass]="{'actionRotateArrowClose': showTowns, 'actionRotateArrowOpen': !showTowns}" />
            </div>
            <app-multi-select [title]="`${fromLocation()}-towns`" [elements]="towns()" [values]="selectedTowns" [width]="'55'" [dropdownParent]="'dropdownTripChangeArea'" [showDropDown]="showTowns" [orderById]="false" [showItemEdit]="showItemEdit()" [pinSelectedToTop]="true" [showSelectAll]="true" (change)="onMultiSelectChange($event)" (editClicked)="editTownEventEmitter.emit($event)"/>
        </div>
    </div>
</section>
